module.exports = __webpack_public_path__ + "static/img/DreamHouse.51bbca1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/DreamHouse.jpg
// module id = OZKt
// module chunks = 1